import md5 from 'js-md5';

/**
 * 生成指定范围内的随机小数
 * @param {number} min - 最小值（包含）
 * @param {number} max - 最大值（不包含）
 * @param {number} decimals - 保留小数位数，默认不限制
 * @returns {number}
 */
export function randomDecimal(min = 1, max = 10, decimals = 9) {
	if (min >= max) {
		console.warn('[randomDecimal] min 应小于 max，已自动交换');
		[min, max] = [max, min];
	}

	const result = Math.random() * (max - min) + min;

	if (decimals !== undefined && decimals >= 0) {
		// 使用 Number.EPSILON 避免浮点精度问题
		return Number(Math.round(result + 'e' + decimals) + 'e-' + decimals);
	}

	return result;
}

export function generateSign(json) {
	if (!json || typeof json !== 'object') {
		console.warn('[generateSign] 传入参数不是有效对象');
		return '';
	}

	// 1. 过滤空值 & 按 key 字母升序排列
	const sortedKeys = Object.keys(json)
		.filter(key => json[key] !== undefined && json[key] !== null && json[key] !== '')
		.sort();

	// 2. 拼接为 key=value&key=value 格式
	const queryString = sortedKeys
		.map(key => `${key}=${json[key]}`)
		.join('&');

	const endString = queryString + '&2b11f25e546148d7ad10a8efc515fa72'

	// 3. MD5 加密并转大写（32位）
	return md5(endString).toUpperCase();
}